export default function formatSymbol(symbol: string) {
  const items = symbol.split('_')

  if (items.length === 2) {
    return items.join('/')
  }

  return symbol
}
